"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "../../../client-utils/styled/index.js";
import isEmail from "../../../common-utils/email/isEmail.util.js";
import encodeEmail from "../../../common-utils/email/encodeEmail.util.js";
import Box from "../../../components/atoms/Box/index.js";
import Link from "../../../components/atoms/Link/index.js";
export const EmailAddress = ({ email, encode = true, linkProps, ...props }) => {
    if (!isEmail(email))
        return null;
    const childProps = encode ? { dangerouslySetInnerHTML: { __html: encodeEmail(email) } } : { children: email };
    return (_jsx(Box, { "data-testid": "EmailAddress", ...props, ...linkProps, component: linkProps ? Link : "span", ...childProps }));
};
export const EmailAddressAtomComponent = styled(EmailAddress, {
    name: "SdbEmailAdress",
    slot: "Root",
})(({ theme }) => ({
    color: theme.vars.palette.surface.onVariant,
}));
export default EmailAddressAtomComponent;
